import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { Card } from 'react-bootstrap';
import { ChevronDoubleRight, FileSpreadsheet } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useReportCells, useReportCellTypes } from '../hooks';
import { type ReportCell } from '../types';

interface Props {
  idVersion: string;
}

interface DisplayProps {
  label?: string;
  value?: any;
}

const DisplayProperties = (props: DisplayProps) => {
  return (
    <p>
      <b>
        {props.label}: {props.value}
      </b>
    </p>
  );
};

export const ReportCellsList = (props: Props) => {
  const [{ data }] = useReportCells(props.idVersion, true);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;

  const cellTypes = useReportCellTypes();
  if (!data) {
    return <></>;
  }
  data.sort((a: any, b: any) => (a.order < b.order ? -1 : 1));
  return (
    <>
      <Row>
        <Col>
          <BtnToolbar>
            {}
            <BtnGroup>{() => {}}</BtnGroup>
            <BtnGroup>
              <Button
                action={ButtonAction.new}
                variant="primary"
                onClick={() => navigate(`${url}/create?disabled=1`)}
              />
            </BtnGroup>
          </BtnToolbar>
        </Col>
      </Row>
      {/* se recorren las celdas definidas para ser presentadas en pantalla */}
      <Row className="mt-3">
        {data &&
          data.map((fc: ReportCell) => (
            <Col xl={4} lg={4} md={6} key={`cell-${fc.id}`}>
              <Card className="mb-4">
                <Card.Header>
                  <Card.Title>
                    <span>{fc.name}</span>
                  </Card.Title>
                  <Card.Subtitle className="font-weight-bold text-body">
                    <span>{fc.code}</span> <span>(</span>
                    <span>{cellTypes.find((value: any) => value.id === fc.type)?.name}</span>
                    <span>)</span>
                  </Card.Subtitle>
                </Card.Header>
                <Card.Body className="d-flex flex-column">
                  <div className="mb-4">
                    {/* formula*/}
                    {fc.formula && (
                      <div className="text-center mt-3 mb-3">
                        <FileSpreadsheet size="32"></FileSpreadsheet>
                        <Card.Text className="ms-2 font-italic">{fc.formula}</Card.Text>
                      </div>
                    )}
                    {/* descripcion */}
                    <Card.Text className="mt-2">{fc.description}</Card.Text>
                  </div>
                </Card.Body>
                <Card.Footer className="text-center py-1">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`${url}/edit/${fc.id}?disabled=1`);
                    }}
                  >
                    {t('common.label.edit')} <ChevronDoubleRight></ChevronDoubleRight>
                  </a>
                </Card.Footer>
              </Card>
            </Col>
          ))}
      </Row>
    </>
  );
};
